import { baseClient, API, authClient } from '../../utils/index';

export const fetchRetailer = async (id) => {
	return baseClient().get(`${API}/retailers/${id}`);
};
